import Price from "components/Price/Price"
import _ from "lodash"
import React from "react"
import {Component} from "react"
import {Link, NavLink, withRouter} from "react-router-dom"
import {Button} from "semantic-ui-react"
import shop from "shop/shop"

import ordinals from "theme/arnoldsports/sortParamsVariant"

@withRouter
export default class Variants extends Component {

	state = {
		selectedArt: false,
	}

	selectType = ( selectedArt ) => {
		this.setState( {selectedArt} )
	}

	componentWillReceiveProps( props ) {
		const {selectByField = "Art"} = props
		if ( props.product !== this.props.product || props.byAttribute && !this.state.selectedArt ) {
			if ( props.product ) {
				this.selectType( props.product.extraValue[selectByField] )
			} else {
				this.selectType( _.keys( props.byAttribute[selectByField] )[0] )
			}
		}
	}

	render() {
		const {byAttribute, product, selectedArt} = this.props
		if ( !byAttribute ) return null
		const pinnedAttr = {}

		if ( shop.config.variantNames ) {
			shop.config.variantNames.forEach( variantKey => {
				pinnedAttr[variantKey] = product.extraValue[variantKey]
			} )
			return (
				<div>
					
					{shop.config.variantNames.map( variantKey => {
						const variants = byAttribute[variantKey]
						const pinned = {...pinnedAttr}
						delete pinned[variantKey]
						const variantKeys = _.keys( variants )
						// TODO: UNIFY
						const keys = variantKeys.sort( ( a, b ) => {
							let s0 = ordinals[a]
							let s1 = ordinals[b]
							if ( !s0 )
								return s0 >= s1 ? 1 : -1
						} )

						if ( !keys || keys.length <= 0 ) return null

						const selected = product.extraValue[variantKey]
						return <div className="variant-group pb3" key={variantKey}>
							<h4>{translate( variantKey )}</h4>
							{
								_.map( keys, ( key ) => {
									let items = variants[key]
									let item = _.first( items.filter( p => {
										let hit = false
										_.forEach( pinned, ( value, key ) => {
											hit = hit || p.extraValue[key] === value
										} )
										return hit
									} ) )

									if ( !item ) {
										item = items[0]
									}
									return <Button size="tiny"
												   as={Link}
												   disabled={!item.available}
												   className={`button-variant ${selected === item.extraValue[variantKey] ? "selected" : null} `}
												   to={{pathname: `/product/${item.map_id}/`, state: {preventScrollToTop: true}}} key={key}
												   onClick={() => this.selectType( key )}
												   basic>{translate( key )}</Button>
								} )
							}
						</div>
					} )}
				</div>
			)
		}
		return (
			<div>
				{byAttribute.Art &&
				<div>
					<h4>Artikelart</h4>
					{_.map( _.keys( byAttribute.Art ), ( key ) => {
						let items = byAttribute.Art[key]
						let item = items[0]
						return <Button size="tiny" as={Link}
									   className={`button-variant ${selectedArt === item.extraValue.Art ? "selected" : null} `}
									   to={{pathname: `/product/${item.map_id}`, state: {preventScrollToTop: true}}} key={key}
									   onClick={() => this.selectType( key )}
									   basic>{translate( key )}</Button>
					} )}
				</div>}

				<h4 className="pt3">Größe</h4>
				{_.map( byAttribute.Groesse, ( items ) => {
					return items
						.filter( p => p.extraValue.Art === selectedArt )
						.map( item => {
							const pathname = `/product/${item.map_id}/`
							return <Button key={item.map_id} className="tl button-variant" size="tiny" basic as={NavLink}
										   activeClassName="selected"
										   active={this.props.location.pathname === pathname}
										   to={{
											   pathname,
											   search: document.location.search,
											   state : {preventScrollToTop: true}
										   }}>{item.extraValue.Groesse} cm
								<br /><Price className="">{item.price}</Price></Button>
						} )
				} )}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Variants/Variants.js